import { CustomDrawer } from '@atbay/component-lib'
import { Sidebar } from '../sidebar'
import { StyledMenuIcon } from './app-navigation.styles'
import './index.scss'

const AppNavigationNew = () => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false)

    return (
        <>
            <div
                data-testid="menu-navigator"
                onClick={() => setMenuOpen(true)}
                className="menu-icon"
            >
                <StyledMenuIcon />
            </div>
            <CustomDrawer
                anchor={'left'}
                open={menuOpen}
                onClose={() => setMenuOpen(false)}
            >
                <Sidebar close={() => setMenuOpen(false)} />
            </CustomDrawer>
        </>
    )
}

export default AppNavigationNew
